<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addPipelineLicenseCategory()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        
      </div>
    </div>

    <div class="custom_table_four_row">
      <form [formGroup]="pipelinelicensecategoryForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">PipelineLicenseCategory Name</span>
          <span class="head">Estimated Duration</span>
        </div>

        <div class="tbody" formArrayName="PipelineLicenseCategorys">
          <div
            class="td"
            *ngFor="
              let pipelinelicensecategorys of pipelinelicensecategoryForm.get('PipelineLicenseCategorys')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="PipelineLicenseCategoryName"
                placeholder="Enter text"
            /></span>

            <span
            ><input
              type="text"
              formControlName="EstimatedDuration"
              placeholder="Enter text"
          /></span>
            <button
                class="delete_icon trash"
                (click)="deletePipelineLicenseCategory(i, pipelinelicensecategorys.value)"
              >
                <em class="ti-trash"> </em> </button
            >
          </div>
        </div>

        <div class="submit">
          <button class="submit_button" (click)="onSubmit(pipelinelicensecategoryForm.value)">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
